<script setup>
const socials = [
  { icon: 'mdi-github', url: 'https://github.com/andikanugraha' },
  { icon: 'mdi-linkedin', url: 'https://www.linkedin.com/in/andika-nugraha/' },
  { icon: 'mdi-instagram', url: 'https://instagram.com/andikanugraha' },
  { icon: 'mdi-youtube', url: 'https://www.youtube.com/channel/UCen44AsghRs-wWosIv8Jepg' },
]
</script>

<template>
  <v-footer class="flex-column pa-6 mt-12">
    <div class="d-flex ga-2 mb-3">
      <v-btn
        v-for="s in socials"
        :key="s.icon"
        :href="s.url"
        target="_blank"
        icon
        variant="text"
        size="small"
      >
        <v-icon size="20">
          {{ s.icon }}
        </v-icon>
      </v-btn>
    </div>
    <div class="text-caption text-medium-emphasis">
      &copy; {{ new Date().getFullYear() }} Andika Nugraha · Built with Nuxt & Vuetify
    </div>
  </v-footer>
</template>
